import Vue from 'vue';
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueLocalStorage from 'vue-localstorage'
import VueHack from './libs/vuehack.plugin'
import Vue2Filters from 'vue2-filters'
import con from './const.js'


import FastClick from 'fastclick'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import AlertPlugin from 'vux/src/plugins/alert/index.js'

import ToastPlugin from 'vux/src/plugins/toast/index.js'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import DatetimePlugin from 'vux/src/plugins/datetime/index.js'


import AnimatedVue from './libs/animated-vue'
import util from './libs/util';
import App from './app.vue';
import WS from './libs/websocket'


import routes from './router1'
import Auth   from './libs/auth'
import cookie from './libs/cookie'

import store from './store'

import NoData from './components/NoData.vue'

import DataScroll from './libs/data-scroll/data-scroll.js'
import MeScroll from '@/libs/mescroll.directive'
/*
import VConsole from 'vconsole';
const vconsole = new VConsole()
*/

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(VueLocalStorage)
Vue.use(VueRouter)
Vue.use(Vue2Filters)
Vue.use(VueResource)
Vue.use(AnimatedVue)
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(VueHack)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(DataScroll)
Vue.use(ConfirmPlugin)
Vue.use(DatetimePlugin)
Vue.use(WS,{store:store})


const RouterConfig = {
base:con.ROUTER_BASE,

linkActiveClass: "active",
routes: routes
};
const router = new VueRouter(RouterConfig);
/**
* 配置路由
* @return {[type]} [description]
*/


function hideAllNonBaseMenuItem () {
if(!util.isWechat()){
return
}
store.dispatch('getJssdkConfig',Vue.wechat)
.then(jssdk=>{
Vue.wechat.hideAllNonBaseMenuItem()
})
};

function showAllNonBaseMenuItem () {
if(!util.isWechat()){
return
}
store.dispatch('getJssdkConfig',Vue.wechat)
.then(jssdk=>{
Vue.wechat.showAllNonBaseMenuItem()
})
};

const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)

function config_router(){
router.beforeEach((to,from,next)=>{
const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)
/*
if(to.meta.show_share){
showAllNonBaseMenuItem()
}else{
hideAllNonBaseMenuItem()
}
*/
if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', {direction: 'forward'})
} else {
store.commit('updateDirection', {direction: 'reverse'})
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', {direction: 'forward'})
}

if(to.meta.show_footer===true){
store.commit('show_footer',true)
}else{
store.commit('show_footer',false)
}

if(to.meta.wxauth && store.state.user.info.openid == ''){
Vue.localStorage.set('referer',to.fullPath)
location.href = store.state.config.OAUTH_URL+'&p='+to.fullPath+'&u='+(Auth.isLogin()?store.state.user.info.uid:'')
}
if(!to.meta.public) {
let nextPage = Vue.localStorage.get(con.NP_KEY)
if (Auth.isLogin()) {
if(to.meta && to.meta.title){
util.title(to.meta.title,store.state.sys_name)
}
if(nextPage){
Vue.localStorage.set(con.NP_KEY,'')
next({path:nextPage})
}
next()
} else {
if(to.meta && to.meta.title){
util.title(to.meta.title,store.state.sys_name)
}
Vue.localStorage.set(con.NP_KEY,to.fullPath)
if(process.env.NODE_ENV === 'production'){
let url = 'http://' + document.domain + '/sapi/open/login_oauth'
window.location.href = url
}else{
next({path:'login'})
}
}
}else{
if(to.meta.user){
Auth.isLogin()
}
if(to.meta && to.meta.title){
util.title(to.meta.title,store.state.sys_name)
}
next()
}
})

router.afterEach(() => {

});
}

/**
* http全局配置
* @return {[type]} [description]
*/
function config_http(){
Vue.http.options.root = '/sapi';
}

function reg_directives(){
Vue.directive('DataScroll', DataScroll);
Vue.directive('MeScroll', MeScroll);
}

function reg_components(){
Vue.component('NoData',NoData)
}

/**
* 启动App
* @return {[type]} [description]
*/
function start(){
FastClick.attach(document.body)










new Vue({
el:'#app',
router,
store,
render: h => h(App)
})
}

export default {
config_router,
config_http,
reg_directives,
reg_components,
start
}


// WEBPACK FOOTER //
// ./src/bootstrap.js